module.exports = __webpack_public_path__ + "img/vc.02d1fa2e.gif";